@if (loading()) {
  <div class="loading-container">
    <app-loading />
  </div>
}

<div class="countdown-page" style="--theme-color: {{ eventBackgroundColor() }}">
  <div class="countdown-page-card">
    <div class="event-description">
      <h1 class="event-name" [title]="eventName">
        {{ eventName | truncate: 64 }}
      </h1>
      <img class="event-logo" [src]="eventLogoImage" alt="Event logo image" />
      <span
        >{{ event()?.startDateTime | date: 'EEEE, MMMM d AT hh:mm a' }}
        {{ event()?.startDateTime | timezone: 'en' : 'long' }}</span
      >
      <div class="countdown-info">
        <div class="countdown-text">Your event begins in...</div>
        <div class="countdown-section">
          <div class="time-info">
            <div class="time-value">{{ daysLeft() }}</div>
            <div class="time-desc">Days</div>
          </div>
          <div class="time-info">
            <div class="time-value">{{ hoursLeft() }}</div>
            <div class="time-desc">Hours</div>
          </div>
          <div class="time-info">
            <div class="time-value">{{ minutesLeft() }}</div>
            <div class="time-desc">Minutes</div>
          </div>
        </div>
        @if (showJoinButton()) {
          <div class="join-div">
            <div class="countdown-text">Join now!</div>
            <div>
              <button
                class="primary-btn"
                [style]="{ background: event()?.buttonColor, color: event()?.buttonTextColor }"
                [ngClass]="{ 'custom-button': !!event()?.buttonColor }"
                (click)="redirectToButtonAction()"
              >
                Join Event
              </button>
            </div>
          </div>
        } @else {
          <div class="countdown-text">We’re looking forward to seeing you there!</div>
        }
      </div>
    </div>

    <div class="event-tips">
      <div class="tips-info">In the meantime, take the orientation to learn more about Scoot!</div>
      <div class="tips-info">You can also fill out your Smart Badge or test your media permissions ahead of time.</div>
      <div class="flow-buttons">
        @if (hasBadgeQuestions()) {
          <button mat-raised-button class="secondary-btn" (click)="redirectToButtonAction('badge')">
            {{ hasEmptyBadgeInfo() ? 'Fill Out Smart Badge' : 'Edit Smart Badge' }}
          </button>
        }
        <button mat-raised-button [ngClass]="reactiveClass()" (click)="redirectToButtonAction('orientation')">
          {{ hasCompletedDemo() ? 'Take Orientation Again' : 'Scoot Orientation' }}
        </button>
        <button mat-raised-button class="secondary-btn" (click)="redirectToButtonAction('permissions')">
          Check Media Permissions
        </button>
      </div>
    </div>

    <div class="event-calendar">
      <div class="calendar-section">
        <p>Add This Event to your Calendar.</p>
        <div class="calendar-buttons custom-bottom-margin">
          <button class="google" (click)="saveCalendar('google')">Add to Google Calendar</button>
          <button class="outlook" (click)="saveCalendar('outlook')">Add to Outlook Calendar</button>
        </div>
      </div>
      <div class="footer">
        Powered by
        <a href="https://scoot.app/" title="Scoot Page" target="_blank" rel="noopener noreferrer">
          <img alt="Scoot Logo" title="Scoot Logo" src="/assets/images/logos/scoot_logo_primary.png" />
        </a>
      </div>
    </div>
  </div>

  <!-- Presentation Toolbar -->
  <app-presentation-toolbar
    [isPerforming]="false"
    [showZoomControls]="false"
    [isLoadingPresentation]="false"
    [isOrientationExperience]="true"
    [isCountdownPage]="true"
    class="position-presentation-toolbar"
    nativeCursor
  ></app-presentation-toolbar>
</div>
